import React from 'react';
import enhance from './enhance';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

export const Loading = ({ loading }) => (
  <div className={styles.loading}>{loading}</div>
);

Loading.propTypes = {
  loading: PropTypes.string,
};

export default enhance(Loading);
